import React from 'react';
import { Link } from '@/navigation';
import { classNames } from '@/shared/lib/classnames/classnames';
import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
interface Props {
  address: string | null;
  title?: string;
  name?: string;
  link?: string;
  inline?: boolean;
  withGeoIcon?: boolean;
}
export const DoctorCardAddress: React.FC<Props> = ({
  name,
  link,
  address,
  title,
  inline = false,
  withGeoIcon = false
}) => {
  return <>
      <div className={classNames('mt-1', {
      'inline-flex flex-wrap items-center gap-1 md:flex-nowrap': inline
    })}>
        <div className="flex items-center gap-1">
          {withGeoIcon && <svg className="size-6 fill-current text-textPrimary">
              <use xlinkHref={`${baseIcons}#location`}></use>
            </svg>}

          <address className="flex flex-col gap-2">
            {Boolean(title) && <p className="mt-1 text-sm font-medium">{title}</p>}
            {Boolean(address) && <p className="text-xs text-textSecondary md:text-sm">{address}</p>}
          </address>
        </div>

        {name && link && <Link className={classNames('block text-xs text-additionalBlue hover:underline active:text-additionalBlue/80 md:text-sm', {
        'mt-2': !inline
      })} href={{
        pathname: link
      }} target="_blank">
            {name}
          </Link>}
      </div>
    </>;
};